import { atom } from 'jotai';

/**
 * whether or not the user has shared a link
 */
export const sharedAtom = atom(false);
